<template>
  <!-- Ladda ner: one tap opens the share sheet with the film (Spara video, Instagram, chats).
       Tapped before the film is ready, the button shows how far it has come, then that it's
       ready: the share sheet needs that next tap. -->
  <button
    class="slideshow-film-button"
    type="button"
    :aria-busy="state === 'making'"
    :aria-disabled="state === 'making'"
    :class="{ 'is-making': state === 'making', 'is-ready': state === 'ready' }"
    :style="{ '--fill': state === 'ready' ? 1 : percent / 100 }"
  >
    <template v-if="state === 'making'">
      {{ texts.preparingFilm }} {{ percent }} %
    </template>
    <template v-else-if="state === 'ready'">
      <SlideshowIcon name="check" />
      {{ texts.downloadReady }}
    </template>
    <template v-else>
      <SlideshowIcon name="film" />
      {{ texts.downloadShort }}
    </template>
  </button>
</template>

<script lang="ts" setup>
  import { slideshowTexts } from "../../composables/useSlideshow";
  import SlideshowIcon from "./SlideshowIcon.vue";

  defineProps<{ state: "idle" | "making" | "ready"; percent: number }>();

  const texts = slideshowTexts();
</script>
